import { spaceFileExtension, SpaceNodeKind } from 'shared';
import { z } from 'zod';

import { getTranslation } from '../../../utils/get-translation.util';
import { spaceFileNameSchema, spaceNodeNameSchema } from './create-folder.validation';

// The name a folder or a file is renamed to: a new folder's rules (a file's name has no length
// limit), and a file keeps the extension it was uploaded with. The backend checks both and stays
// the source of truth.
export const renameSpaceNodeSchema = (node: { kind: SpaceNodeKind; name: string }) =>
  z
    .object({ name: node.kind === SpaceNodeKind.FILE ? spaceFileNameSchema : spaceNodeNameSchema })
    .strict()
    .refine(
      ({ name }) =>
        node.kind !== SpaceNodeKind.FILE ||
        spaceFileExtension(name) === spaceFileExtension(node.name),
      { message: getTranslation('FILE_EXTENSION_CANNOT_CHANGE'), path: ['name'] },
    );

export type RenameSpaceNodeForm = { name: string };
